import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { enMessages, type MessageId } from './messages.ts';

export function useTranslations(): (id: MessageId, values?: Record<string, string | number>) => string {
	const intl = useIntl();

	return useCallback((id, values) => intl.formatMessage({ defaultMessage: enMessages[id], id }, values), [intl]);
}
